import React from 'react';

const CreditCardSVG = ({ color, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ? width : '24'}
    height={height ? height : '24'}
    viewBox="0 0 24 24"
  >
    <path
      fill={color ? color : '#ffffff'}
      fillRule="evenodd"
      d="M20,4 L4,4 C2.89,4 2.01,4.89 2.01,6 L2,18 C2,19.11 2.89,20 4,20 L20,20 C21.11,20 22,19.11 22,18 L22,6 C22,4.89 21.11,4 20,4 Z M19,18 L5,18 C4.45,18 4,17.55 4,17 L4,12 L20,12 L20,17 C20,17.55 19.55,18 19,18 Z M20,8 L4,8 L4,6 L20,6 L20,8 Z"
    />
  </svg>
);

export default CreditCardSVG;
